import { render, staticRenderFns } from "./ConsultantList.vue?vue&type=template&id=cc97451a"
import script from "./ConsultantList.vue?vue&type=script&lang=js"
export * from "./ConsultantList.vue?vue&type=script&lang=js"
import style0 from "./ConsultantList.vue?vue&type=style&index=0&id=cc97451a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports